<template>
    <div id="showorder">
        <div v-if="order.length>0" class="col-md-5" style="margin-right: 0; margin-left: 0;top: 10px;">
            <div class="row" v-bind:key="good.good" v-for="(good) in order[0].goods">
                    <hr style="margin: 10px;" />
                    <div class="col-xs-2" style="padding-left: 10px; text-align: right;">
                                <!--                                <div class="img-container"><span v-html="photo_src(item)"></span></div>-->
                                {{good.quantity * good.multiplier}}
                            </div>
                    <div class="col-xs-7"  style="padding: 0px;">
                                <div class="row">
                                    <div class="col-xs-12">
                                        {{'x&emsp;' +good.name}}
                                    </div>
                                </div>
                            </div>
                    <div class="col-xs-3"  style="text-align: right;">
                                {{Math.floor(good.price * good.quantity * 100 * good.multiplier) / 100}} p.
                            </div>
            </div>
            <div>
                <hr />
                <center>
                    <button type="button" class="btn btn-wd btn-info" @click="copyorder(order[0].goods)"><span class="btn-label"><i class="fa fa-check"></i></span>
                        Копировать
                    </button>
                </center>
                <br />
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'ShowOrder',
    props: [
      'order_uuid'
    ],
    data () {
      return {
        order: []
      }
    },
    mounted () {
      // console.log('this.orders')
      this.get_order()
    },
    methods: {
      get_order () {
        // console.log(this.order_uuid)
        // eslint-disable-next-line no-return-assign
        this.$db.orders.where({'id': this.order_uuid}).toArray().then((x) => this.order = x)
        // console.log(this.order)
      },
      date_format (dt) {
        // console.log(dt)
        var d = new Date(dt)
        // console.log('d - ' + d)
        // console.log('Date.now - ' + Date.now())
        return d.toLocaleString('ru-RU')
      },
      copyorder (goods) {
        this.$db.order.bulkPut(goods).then(this.$router.push({ name: 'Order' }))
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/ShowOrder.vue